import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function SpiritualLoader() {
  const {
    hasSelectedLanguage,
    setLanguage
  } = useLanguage();
  if (hasSelectedLanguage) return null;
  return <AnimatePresence data-id="element-182">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden" data-id="element-183">
        {/* Lightweight background — no animated blobs for fast initial paint */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#FBF8F3] via-[#F5F1E8] to-[#F9F5EF]" data-id="element-184" />
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at 20% 30%, rgba(212, 165, 116, 0.18) 0%, transparent 60%), radial-gradient(ellipse at 80% 70%, rgba(232, 184, 109, 0.14) 0%, transparent 60%)'
      }} data-id="element-185" />

        {/* Language selector — appears immediately */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        delay: 0.05,
        duration: 0.35,
        ease: 'easeOut'
      }} className="relative z-10 bg-white/90 backdrop-blur-sm rounded-2xl p-10 shadow-2xl max-w-md w-full mx-6" data-id="element-186">
          <h2 className="font-serif text-3xl text-[#2C4A3E] text-center mb-8" data-id="element-187">
            Selecciona tu idioma
          </h2>
          <p className="text-center text-[#4A4A4A] mb-8" data-id="element-188">
            Select your language
          </p>

          <div className="space-y-4" data-id="element-189">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => setLanguage('es')} className="w-full bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] text-[#2C4A3E] py-4 rounded-xl text-lg font-semibold transition-all duration-300 shadow-lg" data-id="element-190">
              🇲🇽 Español Latino
            </motion.button>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => setLanguage('en')} className="w-full bg-gradient-to-r from-[#2C4A3E] to-[#3D5F4E] text-[#FBF8F3] py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow" data-id="element-191">
              🇺🇸 English
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}